export default {
      id: "pattern-mutame-lunette-blanc-usage",
      viewBox: "0 0 161 166",
      url: "../icon/" + "icons.svg#pattern-mutame-lunette-blanc-usage",
      toString: function () {
        return this.url;
      }
    }